import { nil, UIRectangle } from "uicore-ts"
import { CBCheckbox } from "../CBCheckbox"
import { BSColor } from "./BSColor"
import { RHColor } from "./RHColor"
import { css, RHViewUtils } from "./RHViewUtils"

export class RHCheckbox extends CBCheckbox {
    
   
    
    // Static flag to ensure CSS is only injected once
    private static hasInjectedStyles = false
    
    constructor(elementID?: string) {
        
        super(elementID);
        
        // 1. Container Configuration (Bootstrap 5.3 alignment)
        (this as RHCheckbox).configureWithObject({
            style: {
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                padding: "4px 0"
            }
        })
        
        // 2. Label Styling
        this.titleLabel.configureWithObject({
            textColor: RHColor.textPrimary,
            style: {
                fontSize: "1rem",
                fontWeight: "400",
                marginLeft: "8px",
                userSelect: "none"
            }
        })
        
        // 3. Glassmorphic Checkbox Styling
        this.checkbox.configureWithObject({
            style: {
                appearance: "none",
                webkitAppearance: "none",
                width: "1.25em",
                height: "1.25em",
                borderRadius: "0.375rem",
                
                backgroundColor: "rgba(255, 255, 255, 0.4)",
                backdropFilter: "blur(10px)",
                //@ts-ignore
                webkitBackdropFilter: "blur(10px)",
                
                cursor: "pointer",
                margin: "0",
                position: "relative",
                
                // Only transition visual properties, NEVER transform.
                // The layout engine uses transform for positioning.
                transition: "background-color 0.2s, border-color 0.2s, box-shadow 0.2s, filter 0.2s"
            }
        })
        
        this.applyGlobalStyles()
        
    }
    
    
    private applyGlobalStyles() {
        
        if (RHCheckbox.hasInjectedStyles || this.class !== RHCheckbox) {
            return
        }
        
        const classSelector = `.${this.styleClassName}`
        const inputSelector = `${classSelector} input`
        
        const checkmarkSVG = `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e")`
        
        RHViewUtils.injectCSS(css`
            ${inputSelector} {
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                border: 1px solid rgba(0, 0, 0, 0.15);
            }

            ${inputSelector}:checked {
                background-color: ${BSColor.primary.stringValue} !important;
                border-color: ${BSColor.primary.stringValue} !important;
                
                background-image: ${checkmarkSVG};
                background-position: center;
                background-size: contain;
                background-repeat: no-repeat;
                
                box-shadow: 0 4px 12px ${BSColor.primaryShadow.stringValue};
            }

            ${inputSelector}:focus {
                outline: 0;
                box-shadow: 0 0 0 0.25rem ${BSColor.primaryShadow.stringValue};
                border-color: ${BSColor.primaryBorderHover.stringValue};
            }

            ${inputSelector}:hover:not(:checked) {
                background-color: #fff;
                border-color: rgba(0, 0, 0, 0.25);
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
            }

            ${inputSelector}:active {
                /* Removed transform: scale() to avoid conflict with layout engine */
                filter: brightness(0.95);
            }
        `, `RHCheckbox_GlobalStyles`)
        
        RHCheckbox.hasInjectedStyles = true
    }
    
    
    override layoutSubviews() {
        super.layoutSubviews()
        
        const bounds = this.bounds
        const padding = this.core.paddingLength
        const checkboxSize = 20
        
        this.checkbox.frame = new UIRectangle(10, 0, checkboxSize, checkboxSize)
        
        const labelOffset = checkboxSize + 10
        const labelWidth = bounds.width - labelOffset
        
        this.titleLabel.setMaxSizes(nil, labelWidth)
        this.titleLabel.frame = new UIRectangle(
            labelOffset,
            0,
            labelWidth,
            bounds.height
        )
        
        this.titleLabel.style.lineHeight = bounds.height + "px"
        this.titleLabel.style.height = bounds.height + "px"
    }
}
